<template>
  <nuttrema-layout-form-standard :edit="edit" :theme="theme" :saveError="InvitationAccept.saveError">
    <template slot="center">

      <el-form
         label-width="20em"
        :ref="formRef"
        :model="formData"
        :rules="rules"
        :label-position="labelPosition">

        <section>
          <h4 class="section-title">{{ $t('label.basic_information_and_credentials') }}</h4>
          <div class="section-items">

            <el-form-item :label="$t('label.email')">
              <el-col class="el-col--min-21em" :span="14">
                <el-input :value="values.email" :disabled="true"></el-input>
              </el-col>
            </el-form-item>

            <el-form-item :label="$t('label.first_name')" prop="first_name">
              <el-col class="el-col--min-21em" :span="14">
                <el-input v-model="formData.first_name" :disabled="!edit"></el-input>
              </el-col>
            </el-form-item>

            <el-form-item :label="$t('label.last_name')" prop="last_name">
              <el-col class="el-col--min-21em" :span="14">
                <el-input v-model="formData.last_name" :disabled="!edit"></el-input>
              </el-col>
            </el-form-item>

            <el-form-item :label="$t('label.gender')" prop="gender">
              <el-col class="el-col--min-15em" :span="6">
                <el-select v-model="formData.gender" class="w-100" :placeholder="$t('label.select_gender')" :disabled="!edit">
                  <el-option :label="$t('label.male')" value="male"></el-option>
                  <el-option :label="$t('label.female')" value="female"></el-option>
                </el-select>
              </el-col>
            </el-form-item>

            <el-form-item :label="$t('label.date_of_birth')" prop="date_of_birth">
              <el-col class="el-col--min-15em" :span="6">
                <el-date-picker type="date" class="w-100" :placeholder="$t('label.pick_a_date')" v-model="formData.date_of_birth" :disabled="!edit" format="dd/MM/yyyy" value-format="yyyy-MM-dd"></el-date-picker>
              </el-col>
            </el-form-item>

            <el-form-item :label="$t('label.password')" prop="password">
              <el-col class="el-col--min-21em" :span="14">
                <nuttrema-password-input v-model="formData.password"></nuttrema-password-input>
              </el-col>
            </el-form-item>

            <el-form-item :label="$t('label.confirm_password')" prop="confirm_password">
              <el-col class="el-col--min-21em" :span="14">
                <nuttrema-password-input v-model="formData.confirm_password"></nuttrema-password-input>
              </el-col>
            </el-form-item>

            <el-form-item class="el-form-item--footer" style="margin-top: 3em">
              <el-col class="el-col--min-21em" :span="14">
                <el-button class="w-100" type="nuttrema-orange" size="large" :loading="InvitationAccept.saving" @click="submitForm">{{ $t('label.join_instance') }}</el-button>
              </el-col>
            </el-form-item>
          </div>
          <div class="section-help is-right">
            <p><span v-html="_markdown.renderInline($t('label.by_clicking_on_join'))"></span> <a href="">{{ $t('label.terms_and_conditions') }}</a></p>
          </div>
        </section>
      </el-form>
    </template>

  </nuttrema-layout-form-standard>
</template>

<script>
import { get, pick, assign, omitBy, isNil } from 'lodash';

import { validateDate } from 'helpers';

import NuttremaLayoutFormStandard from 'components/ui/layout/nuttrema-layout-form-standard';
import FormStandardBehavior from 'src/components/mixins/form-standard-behavior';
import NuttremaPasswordInput from 'components/ui/input/nuttrema-password-input';

export default {
  name: 'form-participant-join-instance',
  mixins: [FormStandardBehavior],
  props: {
    edit: {
      type: Boolean,
      required: false,
      default: false,
    },
    theme: {
      type: String,
      required: false,
      default: null,
    },
    labelPosition: {
      type: String,
      required: false,
      default: 'right',
    },
    token: {
      required: true,
      default: null,
    },
    InvitationAccept: {
      required: true,
      default: null,
    },
    InvitationPreAccept: {
      required: true,
      default: null,
    },
  },
  components: {
    NuttremaLayoutFormStandard,
    NuttremaPasswordInput,
  },
  data() {
    return {
      values: {
        email: null,
      },
      formData: {
        token: null,
        first_name: null,
        last_name: null,
        date_of_birth: null,
        gender: null,
        password: null,
        confirm_password: null,
      },
      rules: {
        first_name: [
          {
            required: true,
            message: this.formatValidationMessage('validation.required', 'label.first_name', true),
            trigger: 'blur',
          },
        ],
        last_name: [
          {
            required: true,
            message: this.formatValidationMessage('validation.required', 'label.last_name', true),
            trigger: 'blur',
          },
        ],
        date_of_birth: [
          {
            required: true,
            message: this.formatValidationMessage('validation.required', 'label.date_of_birth', true),
            trigger: 'blur',
          },
          {
            validator: validateDate,
            message: this.formatValidationMessage('validation.invalid_date'),
            trigger: 'blur',
          },
        ],
        gender: [
          {
            required: true,
            message: this.formatValidationMessage('validation.required', 'label.gender', true),
            trigger: 'blur',
          },
        ],
        password: [
          {
            required: true,
            trigger: 'blur',
            message: this.formatValidationMessage('validation.required', 'label.password', true),
          },
          {
            min: 8,
            max: 72,
            trigger: 'blur',
            message: this.formatValidationMessage('validation.password_length'),
          },
        ],
        confirm_password: [
          {
            required: true,
            trigger: 'blur',
            message: this.formatValidationMessage('validation.required', 'label.confirm_password', true),
          },
          {
            min: 8,
            max: 72,
            trigger: 'blur',
            message: this.formatValidationMessage('validation.password_length'),
          },
          {
            trigger: 'blur',
            validator: this.validatePassword,
            message: this.formatValidationMessage('validation.confirm_password_not_match'),
          },
        ],
      },
    };
  },
  methods: {
    validatePassword(rule, value, callback) {
      console.log('in validatePassword');
      if (value === '') {
        callback(new Error('Please input the password again'));
      } else if (value !== this.formData.password) {
        callback(new Error('Confirm password should be same as new password!'));
      } else {
        callback();
      }
    },
    getFormData() {
      const payload = this.removeEmpty(this.clone(this.formData));
      const credentials = {
        email: this.values.email,
        password: this.formData.password,
      };

      return {
        payload,
        credentials,
      };
    },
    setFormData() {
      this.values.email = get(this.InvitationPreAccept, 'data.email');
      assign(
        this.formData,
        pick(omitBy(this.InvitationPreAccept.data, isNil), [
          'first_name',
          'last_name',
        ]),
        { token: this.token },
      );
    },
  },
  created() {
    this.stateData = this.InvitationAccept;
    this.formRef = 'form-participant-join-instance';
    this.setFormData();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/pages/shared/join-instance/form-join-instance.vue